module.exports = __webpack_public_path__ + "static/media/illustration-choose-one.f887571f.svg";